import React from 'react';
import { Eye, Edit, Key, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const EtudiantActionButtons = ({ 
  etudiant, 
  onEdit, 
  onCreateAccount 
}) => {
  const navigate = useNavigate();

  // Vérifier directement si l'étudiant a un compte utilisateur
  // La relation est stockée dans etudiant.utilisateur
  const hasAccount = etudiant.utilisateur !== null && etudiant.utilisateur !== undefined;
  
  // Debug: afficher les informations de l'étudiant
  console.log('Étudiant:', etudiant.nom, etudiant.prenom, 'Utilisateur:', etudiant.utilisateur, 'HasAccount:', hasAccount);

  return (
    <div className="flex justify-end space-x-2">
      <button
        onClick={() => navigate(`/etudiant/${etudiant.id}`)}
        className="text-indigo-600 hover:text-indigo-900"
        title="Voir les détails"
      >
        <Eye className="h-5 w-5" />
      </button>
      
      <button
        onClick={() => onEdit(etudiant)}
        className="text-blue-600 hover:text-blue-900"
        title="Modifier"
      >
        <Edit className="h-5 w-5" />
      </button>
      
      {/* Bouton de création de compte - masqué si l'étudiant en a déjà un */}
      {!hasAccount && (
        <button
          onClick={() => onCreateAccount(etudiant)}
          className="text-green-600 hover:text-green-900"
          title="Créer un compte"
        >
          <Key className="h-5 w-5" />
        </button>
      )}
      
      {/* Indicateur si l'étudiant a déjà un compte */}
      {hasAccount && (
        <div className="text-green-600" title="Compte utilisateur déjà créé">
          <Key className="h-5 w-5 opacity-50" />
        </div>
      )}
      
      {etudiant.email && (
        <a
          href={`mailto:${etudiant.email}`}
          className="text-green-600 hover:text-green-900"
          title="Envoyer un email"
        >
          <Mail className="h-5 w-5" />
        </a>
      )}
    </div>
  );
};

export default EtudiantActionButtons;
